/**
 * @author Akshay Kumar Singh
 * @file CreateUser Modal
 * @flow
 */
import React, { useState, useEffect } from 'react';
import Modal from 'react-responsive-modal';
import Validator from '../../shared/validator'
import AlertModal from './AlertModal';
import { spinnerService } from '../services/spinner.service';
import { CallApi } from '../services/api.service';
import { useHistory } from "react-router-dom";
import CONFIG from '../../configuration/config'
import validator from '../../shared/validator';
import { USER_ROLES, LABLES, STRINGS } from '../constants/data';

const FAQUploadModal = ({ isFAQModalOpen, closeModal }) => {

  const history = useHistory()
  const [, forceUpdate] = useState();

  const [state, setState] = useState({
    fileFormData: '',
    fileName: '',
    role: '',
    roleArr: [
      { id: 1, value: USER_ROLES.AuditManager },
      { id: 2, value: USER_ROLES.Auditor },
      { id: 3, value: USER_ROLES.Reviewer },
      { id: 4, value: USER_ROLES.PlantManager },
      { id: 5, value: USER_ROLES.PlantAuditor },
      { id: 6, value: USER_ROLES.PlantReviewer }
    ]
  });

  useEffect(() => {
    Validator.hideMessages();
  }, [])

  /**
   * @description This function hides validation messages and closes create user modal.
   */
  const handleModal = (event) => {
    event.preventDefault();
    Validator.hideMessages();
    closeModal();
  }

  /**
   * @description This function sets value of state variables
   */
  const handleChange = (event) => {
    const { name, value } = event.target;
    setState({
      ...state,
      [name]: value
    });
  }

  /**
   * @description This function uploads FAQ PDF with its respective role.
   */
  const onSubmit = (event) => {
    event.preventDefault();
    const { role, fileFormData, fileName } = state;
    if (validator.allValid()) {
      handleModal(event);
      let formData = new FormData();
      formData.append("file", fileFormData);
      formData.append("roleName", role);
      spinnerService.show(LABLES.Oval, STRINGS.FAQLOADERMSG);
      CallApi(LABLES.POST, CONFIG.uploadFAQ, {}, formData, '', uploadFAQCallback, history);
    } else {
      Validator.showMessages();
      forceUpdate({})
      AlertModal.showAlert(STRINGS.AllFieldRequired);
    }
  }

  /**
 * @description uploadFAQCallback API callback function
 * @param response This is the response structure received from API
 */
  const uploadFAQCallback = (response) => {
    if (response.success) {
      AlertModal.showAlert(response.message);
    }
  }

  /**
  * @description This function handles the FAQ PDF file.
  */
  const handleFile = event => {
    let { files } = event.target;
    let fileData = files[0];
    if (fileData && (fileData.type === 'application/pdf')) {
      setState({
        ...state,
        fileFormData: fileData,
        fileName: `(${fileData.name})`
      });
    } else {
      setState({
        ...state,
        fileFormData: '',
        fileName: ''
      });
      event.target.value = null
      AlertModal.showAlert('Please upload PDF file only.')
    }
  }

  return (
    <Modal open={isFAQModalOpen} onClose={handleModal} center>
      <div className="pop-up-bg" id="create-audit-popup">
        <div className="rqst-accs-popup">
          <div className="create-audit-outer">
            <div className="top-cntnt">
              <h4> {LABLES.UploadFAQ} </h4>
              <a href="" onClick={handleModal}>
                <img src={require("../../assets/images/cross-icon.png")} alt="cross-icon" />
              </a>
            </div>
          </div>
          <div className="form-cntnt">
            <form action="" onSubmit={onSubmit}>
              <div className="form-row">
                <div className="column-three">
                  <div className="form-group">
                    <label htmlFor="">{LABLES.Role}</label>
                    <select
                      className={"form-control " + (Validator.message('role', state.role, 'role') ? 'error' : '')}
                      onChange={handleChange} defaultValue='' name='role'
                      style={{ textTransform: 'capitalize' }}
                      onKeyPress={() => Validator.showMessageFor('role')}>
                      <option hidden value=''>{STRINGS.SelectRole}</option>
                      {state.roleArr.map((data, index) => {
                        return (
                          <option key={data.id} value={data.value}>
                            {data.value}
                          </option>
                        )
                      })}
                    </select>
                    <div className='srv-validation-message'>{Validator.message('role', state.role, 'role')}</div>
                  </div>
                </div>
                <div className="column-three">
                  <div className="form-group">
                    <label htmlFor="">{LABLES.PDFUpload}</label>
                    <div className="upload-file-control">
                      <input type="file" className={"form-control" + (Validator.message('FAQFile', state.fileName, 'FAQFile') ? 'error' : '')}
                        id="2" name="FAQFile" onChange={handleFile}
                        onKeyPress={() => Validator.showMessageFor('FAQFile')} />
                      <label htmlFor="2">Upload File {state.fileName}</label>
                      <div className='srv-validation-message'>{Validator.message('FAQFile', state.fileName, 'FAQFile')}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="crt-odi-btn-otr">
                <button className="btn-prmry" type="submit" style={{ backgroundColor: '#005daa' }}
                > {LABLES.UploadFAQ}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Modal>
  );
}
export default FAQUploadModal;